import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import PageHeader from "../components/common/PageHeader";
import WebscrapingComponent from "../components/WebscrapingComponent";
const WebScraping = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div>
      <div className="flex min-h-screen bg-white text-gray-700">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 ml-[250px] p-6 overflow-y-auto">
          <PageHeader
            title="Web Scraping"
            onMenuClick={() => setSidebarOpen(true)}
          />
          <WebscrapingComponent />
        </main>
      </div>
    </div>
  );
};

export default WebScraping;
